<template>
  <InJzxTool
    @event-handle="eventHandle"
  />
</template>
<script>
import InJzxTool from '@/components/InJzxTool/index.vue'
export default {
  components: {
    InJzxTool
  },
  methods: {
    eventHandle(data) {
    }
  }
}
</script>